import { Box, Button, TextField, IconButton } from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';

interface FormsProposalProps {
  formData: {
    subTitle: string;
    wallpaper?: File | null;
    logos: (File | null)[];
  };
  onChange: (data: {
    subTitle?: string;
    wallpaper?: File | null;
    logos?: (File | null)[];
  }) => void;
  goToNextPage: () => void;
}

const FormsProposalFirst: React.FC<FormsProposalProps> = ({
  formData,
  onChange,
  goToNextPage,
}) => {
  function handleWallpaperChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0] ?? null;
    onChange({ wallpaper: file });
  }

  function handleLogoChange(index: number, file: File | null) {
    const updatedLogos = [...formData.logos];
    updatedLogos[index] = file;
    onChange({ logos: updatedLogos });
  }

  function handleRemoveLogoField(index: number) {
    const updatedLogos = [...formData.logos];
    updatedLogos.splice(index, 1);
    onChange({ logos: updatedLogos });
  }

  function handleAddLogoField() {
    onChange({ logos: [...formData.logos, null] });
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: '#202940',
        width: '99%',
        height: '80%',
        boxShadow: '0 4px 24px rgba(24, 19, 19, 0.25)',
        padding: 3,
        marginX: 1,
        gap: 2,
      }}
    >
      <Box
        component="h2"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#fff', mb: 2 }}
      >
        Preencher dados
      </Box>

      <TextField
        variant="outlined"
        label="Subtítulo"
        type="text"
        name="subTitle"
        placeholder="Subtítulo"
        value={formData.subTitle}
        onChange={(e) => onChange({ subTitle: e.target.value })}
        fullWidth
      />

      <TextField
        variant="outlined"
        label="Wallpaper"
        fullWidth
        type="file"
        name="wallpaper"
        InputLabelProps={{ shrink: true }}
        inputProps={{ accept: 'image/*' }}
        onChange={handleWallpaperChange}
        sx={{ borderRadius: 1 }}
      />

      {formData.logos.map((logo, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: 1,
          }}
        >
          <TextField
            variant="outlined"
            fullWidth
            label={`Logo ${index + 1}`}
            type="file"
            InputLabelProps={{ shrink: true }}
            inputProps={{ accept: 'image/*' }}
            onChange={(e) => {
              const input = e.target as HTMLInputElement;
              handleLogoChange(index, input.files?.[0] ?? null);
            }}
            sx={{ borderRadius: 1 }}
          />
          <IconButton
            aria-label="Limpar imagem"
            color="warning"
            onClick={() => handleLogoChange(index, null)}
          >
            <ClearIcon />
          </IconButton>

          <IconButton
            aria-label="Remover campo"
            color="error"
            onClick={() => handleRemoveLogoField(index)}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}

      <Button
        variant="outlined"
        onClick={handleAddLogoField}
        sx={{
          borderColor: '#fff',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#ffffff10',
            borderColor: '#fff',
          },
        }}
      >
        + Adicionar logo
      </Button>

      <Button
        onClick={goToNextPage}
        sx={{
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#115293',
          },
        }}
        variant="contained"
      >
        Salvar
      </Button>
    </Box>
  );
};

export default FormsProposalFirst;
